import { render } from "./VNav.vue?vue&type=template&id=2223a45e&scoped=true"
import script from "./VNav.vue?vue&type=script&lang=js"
export * from "./VNav.vue?vue&type=script&lang=js"

import "./VNav.vue?vue&type=style&index=0&id=2223a45e&scoped=true&lang=css"

import exportComponent from "D:\\code\\humanbrainview\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2223a45e"]])

export default __exports__